import { render, staticRenderFns } from "./complianceTemplateTable.vue?vue&type=template&id=2fda25ea&scoped=true&"
import script from "./complianceTemplateTable.vue?vue&type=script&lang=js&"
export * from "./complianceTemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./complianceTemplateTable.vue?vue&type=style&index=0&id=2fda25ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda25ea",
  null
  
)

export default component.exports